module.exports = __webpack_public_path__ + "img/rainbowmaki.5d5019ed.jpg";